import styled from 'styled-components';

export const ModalBody = styled.div(({
  theme: {
    indents,
  },
}) => ({
  paddingLeft: indents.INDENT_2,
  paddingRight: indents.INDENT_2,
  marginBottom: indents.INDENT_2,
  marginTop: indents.INDENT_2,
}));
